export default __webpack_public_path__ + "static/media/horse-intro.d6a24a8c.png";